/* N1 · Vídeos: un solo vídeo con sonido a la vez en toda la página.
   Cuando un vídeo empieza a sonar, los demás se silencian y se pausan. */
(function(){
if(window.N1VidSolo)return;window.N1VidSolo=1;
function others(v){return [].slice.call(document.querySelectorAll('video')).filter(function(x){return x!==v})}
document.addEventListener('play',function(e){
  var v=e.target;if(!v||v.tagName!=='VIDEO')return;
  if(v.muted)return;
  others(v).forEach(function(x){try{x.muted=true;x.pause()}catch(err){}
    var box=x.closest('.v,.n1v-box');if(box){box.classList.add('muted');var b=box.querySelector('.snd');if(b)b.classList.add('muted')}
  });
},true);
document.addEventListener('volumechange',function(e){
  var v=e.target;if(!v||v.tagName!=='VIDEO'||v.muted)return;
  others(v).forEach(function(x){try{x.muted=true}catch(err){}
    var box=x.closest('.v,.n1v-box');if(box){box.classList.add('muted');var b=box.querySelector('.snd');if(b)b.classList.add('muted')}
  });
},true);
})();
